/**
 * Build a single searchable text blob for a run-report case row.
 *
 * @param {Object} caseItem
 * @returns {string}
 */
export const buildReportCaseSearchText = (caseItem) => {
  const parts = [
    caseItem?.name,
    caseItem?.session_id,
    caseItem?.status,
    caseItem?.error,
    caseItem?.note,
  ];
  const exchanges = Array.isArray(caseItem?.exchanges) ? caseItem.exchanges : [];
  exchanges.forEach((exchange) => {
    parts.push(exchange?.message, exchange?.answer);
  });
  return parts
    .map((value) => String(value || '').trim())
    .filter(Boolean)
    .join('\n')
    .toLowerCase();
};

/**
 * Filter run-report cases by a case-insensitive query (all terms must match).
 *
 * @param {Array<Object>} cases
 * @param {string} query
 * @returns {Array<Object>}
 */
export const filterReportCasesBySearch = (cases, query) => {
  const list = Array.isArray(cases) ? cases : [];
  const trimmed = String(query || '').trim().toLowerCase();
  if (!trimmed) return list;
  const terms = trimmed.split(/\s+/).filter(Boolean);
  if (terms.length === 0) return list;
  return list.filter((caseItem) => {
    const haystack = buildReportCaseSearchText(caseItem);
    return terms.every((term) => haystack.includes(term));
  });
};
